import React from 'react';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import CounterField from 'components/UI/V3/CounterField/CounterField';
import { SESSION_BOOKING_TYPES } from 'model/Service';
import styles from './MaxPetsSection.module.scss';

interface MaxPetsSectionProps {
    maxPets: number;
    bookingType: string;
    onChange: (maxPets: number) => void;
}

export const MaxPetsSection: React.FC<MaxPetsSectionProps> = ({ maxPets, bookingType, onChange }) => {
    if (bookingType === SESSION_BOOKING_TYPES.PRIVATE_SESSION) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Label className={styles.label}>Max # of Pets</Label>
            <CounterField
                value={maxPets}
                onChange={onChange}
                minLimit={2}
                maxLimit={999}
                hasBorder={true}
                className={styles.counter}
            />
        </div>
    );
};
